import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { Observable } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { refreshJwt, refreshTokenItem } from "../../auth";
export const promiseToObservable = promise => new Observable(subscriber => {
  promise.then(value => {
    if (subscriber.closed) return;
    subscriber.next(value);
    subscriber.complete();
  }, err => {
    subscriber.error(err);
  });
});
export const errorLink = onError(error => {
  const {
    networkError,
    operation,
    forward
  } = error;
  if (networkError) {
    const netError = networkError;
    // Check if error response is JSON
    try {
      JSON.parse(netError.bodyText);
    } catch (e) {
      // If not replace parsing error message with real one
      networkError.message = netError.bodyText;
    }
    const token = localStorage.getItem(refreshTokenItem);
    if (token && netError.statusCode === 401) {
      // if forbidden error, then try to refresh jwt token and repeat the operation
      return promiseToObservable(refreshJwt()).flatMap(() => forward(operation));
    }
  }
});